import type { ReactNode } from "react";
import type BizminerOrganizationDisplay from "@/_generated/types/serializers/BizminerOrganizationDisplay";
import DataFlowAnimation from "@/components/DataFlowAnimation.tsx";
import { Card, CardContent, CardHeader } from "@/components/ui/card.tsx";
import { useDarkMode } from "@/hooks/use-dark-mode.tsx";

interface AuthCardProps {
  organization?: BizminerOrganizationDisplay;
  subtitle: string;
  children: ReactNode;
}

export function AuthCard({ organization, subtitle, children }: AuthCardProps) {
  useDarkMode();

  return (
    <div className="relative min-h-svh flex flex-col items-center justify-center overflow-hidden">
      <DataFlowAnimation className="absolute inset-0 z-0" />

      <div className="relative z-10 w-full max-w-md px-6">
        <Card className="border-border/50 bg-card/95 backdrop-blur-sm">
          <CardHeader>
            {organization ? (
              <div className="flex items-center justify-center gap-3 mb-2">
                {organization.logo_thumb_url && (
                  <div className="flex size-12 items-center justify-center rounded-lg border border-border/50 bg-muted/30 p-2">
                    <img
                      src={organization.logo_thumb_url}
                      alt={organization.name}
                      className="max-h-full max-w-full object-contain"
                    />
                  </div>
                )}
                <h1 className="text-2xl font-semibold text-foreground tracking-tight">
                  {organization.name}
                </h1>
              </div>
            ) : (
              <div className="flex items-center justify-center gap-4">
                <img
                  src="/logos/Vitelis_Logomark-Light.svg"
                  alt="Vitelis"
                  className="h-12 w-auto"
                />
                <h1 className="text-3xl font-semibold text-white tracking-tight">
                  Vitelis
                </h1>
              </div>
            )}
            <div className="flex flex-col items-center text-center">
              <p className="text-muted-foreground">{subtitle}</p>
            </div>
          </CardHeader>

          <CardContent className="flex flex-col gap-6">{children}</CardContent>
        </Card>

        <div className="flex items-center justify-center gap-2 mt-4 text-muted-foreground text-sm">
          <span>Powered by</span>
          <img
            src="/logos/Vitelis_Logomark-Light.svg"
            alt="Vitelis"
            className="h-4 w-auto"
          />
          <span>Vitelis</span>
        </div>
      </div>
    </div>
  );
}
